export default __webpack_public_path__ + "static/media/WeatherApp.61a6c8eb.png";